import transportImage from "common/img/factors-transport.jpg";
import energyImage from "common/img/factors-energy.jpg";
import nutritionImage from "common/img/factors-nutrition.jpg";
import householdHabitsImage from "common/img/factors-household-habits.jpg";

export interface Factor {
  title: string;
  color: string;
  image: string;
  description: string;
}

export const FACTORS: Factor[] = [
  {
    title: "Movilidad",
    color: "#a6be0a",
    image: transportImage,
    description:
      "La movilidad es una constante en la vida cotidiana del ser humano, por ello es uno de los factores que incrementa nuestra huella de carbono. El coche, por ejemplo, emite 104 gr de CO2 por Km y pasajero.",
  },
  {
    title: "Energía",
    color: "#1a5690",
    image: energyImage,
    description:
      "Si bien la energía es un factor irrenuncible para cualquiera, su producción, especialmente a partir de fuentes no renovables, provocan el aumento considerable de las emisiones de CO2 convirtiéndolo en una de las areas con mayor impacto en la huella de carbono.",
  },
  {
    title: "Alimentación",
    color: "#e37222",
    image: nutritionImage,
    description:
      "La producción de alimentos supone un importante peso en la huella de carbono y medioambiente, provocando la deforestación o el gran consumo de recursos como es el agua, entre otros. Dentro de la producción los productos de origen animal son los que mayor porcentaje de contaminación producen.",
  },
  {
    title: "Hogar",
    color: "#e8153b",
    image: householdHabitsImage,
    description:
      "En la vivienda realizamos tareas cotidianas como cocinar, lavar la ropa, encender la televisión entre otras. Estas influyen en mayor o menor medida, en tu huella de carbono. También influye el tipo de energía que utilices en tu hogar.",
  },
];
